// extracted by mini-css-extract-plugin
module.exports = {"container":"togglePayment_container__1hZI0","halfSection":"togglePayment_halfSection__Ti54Q","selectedPlaceholder":"togglePayment_selectedPlaceholder__2ELD0","selectedPlaceholderBis":"togglePayment_selectedPlaceholderBis__2f3KP"};
    if(module.hot) {
      // 1790670319317
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  